import {FC} from 'react';

type UICardHeaderProps = {
  title: string;
  description?: string;
  longer?: boolean;
  padding?: boolean;
}

const UICardHeader: FC<UICardHeaderProps> = ({title, description, longer, padding = true}) => {
  return (
    <div className={`flex justify-between items-start pb-4 ${padding ? 'pl-5' : ''}`}>
      <div className={`font-Outfit ${longer ? 'max-w-[630px]' : 'max-w-[200px]'}`}>
        <div className='text-22 font-medium'>{title}</div>
        <div className='text-sm font-normal leading-4 text-brown-subtitle'>{description}</div>
      </div>
    </div>
  );
};

export default UICardHeader;
